import React, { useState } from 'react';
import * as R from 'ramda';
import onlinePayment from './../../../assets/images/svg/053-online-payment.svg';
import { AddVirementForm } from '../modal/addVirementForm';


export const VirementTile = ({ user, paymentMethod }) => {
    const [ownerState, setOwnerState] = useState({
        name: `${user.firstName} ${user.lastName}`,
        email: `${user.email}`
    });

    return (
        <div className="card shadow-xs mb-2">
            <div className="card-header flex-row justify-content-around">
                <img className="img-fluid w-4 my-auto mr-2 h-5" src={onlinePayment} alt="virement" />
                <h2 className="h5 text-uppercase font-weight-bolder my-auto mr-auto">Virement</h2>
            </div>
            <div className="card-body py-0">
                <div className="row gx-2">
                    <div className="col">
                        <AddVirementForm ownerState={ownerState} setOwnerState={setOwnerState} paymentMethod={paymentMethod} user={user} />
                    </div>
                </div>
                {
                    !R.isNil(paymentMethod) ? <button type="button" className="btn btn-block btn-alert-info px-3 mb-xs" data-toggle="modal" data-target="#payment">Modifier la méthode de paiement</button> : ''
                }
            </div>
        </div>
    );
};